import React, {Component} from 'react';
import Address from './Address';
import { connect } from "react-redux";
import Tokenizer from './Tokenizer';
import WalletApp from './WalletApp';
import PaymentMiniApp from './PaymentMiniApp';
import Terms from './Terms';
import {
  getUrlQueryParams,
  isPaymentMiniApp,
} from '../../utils/payment-mini-app-utils';
import Loader from '../Common/Loader';
import { withTranslation } from 'react-i18next';
import { loadCountryStateList, setTermsConditionAccepted } from '../../actions/UserInfoActions';
import LoggerService from '../../services/LoggerService';
import _ from "lodash";

class Wrapper extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.state = {
            page:1,
            formValue: {},
            isAddressEnabledCountry: false,
            userDetails: {}
        }
        this.validateConfigCountry = this.validateConfigCountry.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.tokenUpdated = this.tokenUpdated.bind(this);
        this.handleTermsConditionAccepted = this.handleTermsConditionAccepted.bind(this);
        this.props.loadCountryStateList(this.props.userCountryCode);
    }
    getAddressFieldData() {
        let address = [];
        address.push(this.props.userDetails['address.mail_to']['line1']);
        address.push(this.props.userDetails['address.mail_to']['line2']);
        address.push(this.props.userDetails['address.mail_to']['line3']);
        return address.filter(function(element) {return element!== undefined && element!==null && element.trim().length > 0}).join(", ");
    }
    componentDidMount(){
        var isAddressEnabledCountry = this.validateConfigCountry(this.props.userCountryCode);
        var initialAddress = {};


        if(_.has(this.props.userDetails, 'address.mail_to') && !_.isUndefined(this.props.userDetails.address) && !_.isUndefined(this.props.userDetails['address.mail_to']))
        {
            initialAddress = {
                "address"       : this.getAddressFieldData(),
                "city"          : this.props.userDetails['address.mail_to']['city'] || "",
                "state"         : this.props.userDetails['address.mail_to']['stateProv'] || "",
                "postalCode"    : this.props.userDetails['address.mail_to']['postalZip'] || "",
                "countryCode"   : this.props.userDetails['address.mail_to']['countryCode']
            }
        }
        else if(this.props.userDetails && this.props.userDetails.address){
            var addressList = this.props.userDetails.address.split(",");
            if(addressList && addressList.length === 6){
                initialAddress = {
                    "address"       : addressList[0].replace(/null/gi, ''),
                    "city"          : addressList[1],
                    "state"         : addressList[2].replace(/null/gi, ''),
                    "postalCode"    : addressList[4],
                    "countryCode"   : addressList[5]
                }
            }else{
                initialAddress = {
                    "address"           : "",
                    "city"              : "",
                    "state"             : "",
                    "postalCode"        : "",
                    "countryCode"       : this.props.userDetails.countryCode
                }
            }
        }

        if(this.props.userDetails && _.isUndefined(this.props.userDetails.address)) {
            initialAddress = {
                "address"           : "",
                "city"              : "",
                "state"             : "",
                "postalCode"        : "",
                "countryCode"       : this.props.userDetails.countryCode
            }
        }
        this.setState({
            isAddressEnabledCountry: isAddressEnabledCountry,
            userDetails: {
                'first_name': _.has(this.props.userDetails,'first_name') ? this.props.userDetails.first_name : '',
                'last_name': _.has(this.props.userDetails,'last_name') ? this.props.userDetails.last_name : '',
                'phoneNumber': _.has(this.props.userDetails,'phoneNumber') ? this.props.userDetails.phoneNumber : '',
                'email':  _.has(this.props.userDetails,'email') ? this.props.userDetails.email : '',
                'countryCode' : _.has(this.props.userDetails,'countryCode')? this.props.userDetails.countryCode : '',
                'userAddress' : initialAddress
            }
        });

    }
    

    componentDidUpdate(prevProps) {
        const { payMiniActive } = this.getPaymentMiniAppFlowState();
        if((this.props.tokenUpdateSuccessFlag !== prevProps.tokenUpdateSuccessFlag) || ((this.props.featureFlags && this.props.featureFlags.length && (prevProps.featureFlags !== this.props.featureFlags) && (this.props.featureFlags.indexOf("ENABLE_TNC_EVENT") === -1) && !payMiniActive) || ((prevProps.eventList !== this.props.eventList) && this.props.eventList.length === 0 && !payMiniActive))) // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id) OR Feature flag for Terms and Condition event
        {
          this.tokenUpdated();
        }
      }

    nextPage(formValue) {
        this.setState({ page: this.state.page + 1, formValue: formValue });
        this.setState(prevState => ({
            userDetails: {                   // object that we want to update
                ...prevState.userDetails,    // keep all other key-value pairs
                userAddress: formValue      // update the value of specific key
            }
        }))
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 })
    }

    tokenUpdated(){
        this.setState({ page: this.state.page + 1 })
    }

    /**
     * PI parity pay-link flow: Floodgate ENABLE_PAYMENT_MINI_APP and a non-empty `orderId` in the URL
     * (search or hash query — same as {@link isPaymentMiniApp}).
     */
    getPaymentMiniAppFlowState() {
        const orderIdFromUrl = String(getUrlQueryParams().orderId || '').trim();
        const hasOrderIdInUrl = orderIdFromUrl.length > 0;
        const payMiniCtx = isPaymentMiniApp();
        const featureOn =
            this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_PAYMENT_MINI_APP") > -1;
        const payMiniActive = featureOn && hasOrderIdInUrl;
        return { payMiniCtx, payMiniActive };
    }

    handleTermsConditionAccepted(){
        this.props.setTermsConditionAccepted(true);
        this.setState({ page: this.state.page + 1 });
        const messageObject = {};
        messageObject.Message = 'Terms and Condition Accepted Successfully';
        messageObject.Functionality = 'Terms and Condition Accepted';
        messageObject.Source_System = 'HDX';
        messageObject.Flow = 'Terms and Condition Accepted';
        messageObject.Screen = 'SecurePaymentPortal';
        messageObject.CustomerGuid = _.has(this.props.userDetails, 'authId') ? this.props.userDetails.authId : '';
        messageObject.countryCode = _.has(this.props.userDetails, 'countryCode') ? this.props.userDetails.countryCode : '';
        messageObject.Result = 'Success';
        LoggerService.saveSplunkLog(messageObject, 'info');
    }
    addressForm() {        
        const { page } = this.state;
        if(!this.props.countryStates) {
            return;
        }
        const { payMiniCtx, payMiniActive } = this.getPaymentMiniAppFlowState();
        return(
            <div>
                {page === 1 &&  <Terms onClick={this.handleTermsConditionAccepted}/>}
                {page === 2 && <Address initialValues={{country: this.props.userCountryCode, state:this.props.stateCode || this.state.userDetails.userAddress.state,address: this.state.userDetails.userAddress.address, city:this.state.userDetails.userAddress.city, postalCode:this.state.userDetails.userAddress.postalCode}} stateCode={this.props.stateCode} countryStates={this.props.countryStates} countries={this.props.countries} userCountryCode={this.props.userCountryCode} onSubmit={this.nextPage}/>}
                {page === 3 && payMiniActive && <div className={this.props.isLoaderStatus ? "disableComponent" : ''}><PaymentMiniApp style={this.props.isLoaderStatus ? {pointerEvents: "none", opacity: "0.4"} : {}} userDetailsForTokenizer={this.state.userDetails} payLinkOrderId={payMiniCtx.orderId} previousPage={this.previousPage} tokenUpdated={this.tokenUpdated} disableComponent={this.props.isLoaderStatus} enableBackButton={this.state.isAddressEnabledCountry}/></div>}
                {page === 3 && (this.props.featureFlags.indexOf("ENABLE_MINI_WALLET_APP_EVENT") === -1) && !payMiniActive && <div className={this.props.isLoaderStatus ? "disableComponent" : ''}><Tokenizer style={this.props.isLoaderStatus ? {pointerEvents: "none", opacity: "0.4"} : {}} deatils={this.props} address={this.state.formValue} userDetailsForTokenizer={this.state.userDetails} previousPage={this.previousPage} tokenUpdated={this.tokenUpdated} disableComponent={this.props.isLoaderStatus} enableBackButton={this.state.isAddressEnabledCountry}/></div>}
                {page === 3 && (this.props.featureFlags.indexOf("ENABLE_MINI_WALLET_APP_EVENT") > -1) && this.props.eventMiniWallet && !payMiniActive && <div className={this.props.isLoaderStatus ? "disableComponent" : ''}><WalletApp style={this.props.isLoaderStatus ? {pointerEvents: "none", opacity: "0.4"} : {}} userDetailsForTokenizer={this.state.userDetails} eventMiniWallet={this.props.eventMiniWallet} previousPage={this.previousPage} tokenUpdated={this.tokenUpdated} disableComponent={this.props.isLoaderStatus} enableBackButton={this.state.isAddressEnabledCountry}/></div>}
                {page === 4 && ''}
            </div>
        )
    }

    tokenForm() {        
        const { page } = this.state;
        if(Object.keys(this.state.userDetails).length === 0) {
            return;
        }
        const { payMiniCtx, payMiniActive } = this.getPaymentMiniAppFlowState();
        return(
            <div>
                {page === 1 && !payMiniActive && <Terms onClick={this.handleTermsConditionAccepted}/>}
                {page === 1 && payMiniActive && <div className={this.props.isLoaderStatus ? "disableComponent" : ''}><PaymentMiniApp userDetailsForTokenizer={this.state.userDetails} payLinkOrderId={payMiniCtx.orderId} previousPage={this.previousPage} submit={this.submit} tokenUpdated={this.tokenUpdated} disableComponent={this.props.isLoaderStatus} enableBackButton={this.state.isAddressEnabledCountry}/></div>}
                {page === 2 && (this.props.featureFlags.indexOf("ENABLE_MINI_WALLET_APP_EVENT") === -1) && !payMiniActive &&  <div className={this.props.isLoaderStatus ? "disableComponent" : ''}><Tokenizer deatils={this.props} userDetailsForTokenizer={this.state.userDetails} previousPage={this.previousPage} submit={this.submit} tokenUpdated={this.tokenUpdated} disableComponent={this.props.isLoaderStatus} enableBackButton={this.state.isAddressEnabledCountry}/></div>}
                {page === 2 && (this.props.featureFlags.indexOf("ENABLE_MINI_WALLET_APP_EVENT") > -1) && this.props.eventMiniWallet && !payMiniActive && <div className={this.props.isLoaderStatus ? "disableComponent" : ''}><WalletApp userDetailsForTokenizer={this.state.userDetails} eventMiniWallet={this.props.eventMiniWallet} previousPage={this.previousPage} submit={this.submit} tokenUpdated={this.tokenUpdated} disableComponent={this.props.isLoaderStatus} enableBackButton={this.state.isAddressEnabledCountry}/></div>}
                {page === 3 && ''}
            </div>
        )
    }
    validateConfigCountry = (countryCode)=> {
        if(this.props.featureFlags && this.props.featureFlags.indexOf("ENABLE_MINI_WALLET_APP_EVENT") > -1){
            return false;
        }
        if (this.getPaymentMiniAppFlowState().payMiniActive) {
            return false;
        }
        if(this.props.addressEnabledCountryList && this.props.addressEnabledCountryList.length > 0 ) {
            let found = this.props.addressEnabledCountryList.find(function(element) {
                return element === countryCode;
            });
            if(found) {
                return true;
            }
            else{
                return false
            }
        }
        else{
            return false;
        }
    }
    renderLoading(){
        return (<Loader loaderSize="L"/>);
    }

    renderWrapper(){        
        return(
            <div>
                {this.props.isLoaderStatus ? this.renderLoading(): ''}
                {this.props.isEnabledCountry ? this.validateConfigCountry(this.props.userCountryCode) ? this.addressForm() : this.tokenForm() : ""}
            </div>
        )
    }

    render() {
        return(
             this.renderWrapper()
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        countries:state.AppReducer.countries,
        countryStates: state.UserInfoReducer.countryStates,
        stateCode: state.UserInfoReducer.stateCode,
        addressEnabledCountryList: state.AppReducer.addressEnabledCountryList,
        userCountryCode: state.UserInfoReducer.userCountryCode,
        userDetails:state.AuthReducer.userInfo,
        tokenUpdateSuccessFlag: state.SecurePaymentReducer.tokenUpdateSuccessFlag,
        isLoaderStatus: state.SecurePaymentReducer.isLoaderStatus,
        eventList: state.UserInfoReducer.eventTermsCondition,
        isEnabledCountry: state.AuthReducer.isCountryEnabled,
        featureFlags: state.AppReducer.featureFlags,
        eventMiniWallet: state.UserInfoReducer.eventMiniWallet
    }
};
const mapDispatchToProps = (dispatch)=>{
    return{
        loadCountryStateList:(countryCode) => {dispatch(loadCountryStateList(countryCode))},     
        setTermsConditionAccepted:(val) => {dispatch(setTermsConditionAccepted(val))}   
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(Wrapper));